export const getBuildingId = (path: string) => {
  // get all IDs from path
  const ids = getIdsFromPath(path);

  // get building ID from the path, expect its the first element in the array
  const buildingId = ids[0];

  return buildingId;
};

export const getIdsFromPath = (path: string) => {
  // split string by '.'
  const pathArray = path.split('.');

  // replace all '_' with '-' in elements of the array
  const ids = pathArray.map((id) => id.replace(/_/g, '-'));

  return ids;
};
